<script lang="ts">
	import Advertising from '$lib/components/advertising/Advertising.svelte';

	let showAdContainer = $state(false);
</script>

<aside
	class={[
		'unroll flex items-center justify-center w-full mb-8',
		showAdContainer ? 'h-250px min-h-250px overflow-visible' : 'h-0 min-h-0 overflow-hidden',
	]}
>
	<Advertising
		adId="poi-list"
		adFormat="300x250"
		showAdByDefault
		onAdAvailabilityChange={(isAvailable) => {
			showAdContainer = isAvailable;
		}}
	/>
</aside>

<style>
	.unroll {
		transition: height 300ms cubic-bezier(0.85, 0, 0.15, 1) 0s;
	}
</style>
